import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from '@edx/frontend-platform/i18n';
import PropTypes from 'prop-types';

import validateDateofbirth from './validator';
import { FormGroup } from '../../../common-components';
import { clearRegistrationBackendError, fetchRealtimeValidations } from '../../data/actions';

const DateOfBirthField = (props) => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const validationApiRateLimited = useSelector(state => state.register.validationApiRateLimited);

  const {
    handleErrorChange,
  } = props;

  const handleOnBlur = (e) => {
    const { value } = e.target;
    const fieldError = validateDateofbirth(value, formatMessage);
    if (fieldError) {
      handleErrorChange('date_of_birth', fieldError);
    } else if (!validationApiRateLimited) {
      dispatch(fetchRealtimeValidations({ date_of_birth: value }));
    }
  };

  const handleOnFocus = () => {
    handleErrorChange('date_of_birth', '');
    dispatch(clearRegistrationBackendError('date_of_birth'));
  };

  return (
    <FormGroup
      {...props}
      type="date"
      handleBlur={handleOnBlur}
      handleFocus={handleOnFocus}
    />
  );
};

DateOfBirthField.defaultProps = {
  errorMessage: '',
};

DateOfBirthField.propTypes = {
  errorMessage: PropTypes.string,
  value: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleErrorChange: PropTypes.func.isRequired,
};

export default DateOfBirthField;
